var map = {
	"./albanian.png": 1059,
	"./amharic.png": 1060,
	"./arabic.png": 1061,
	"./armenian.png": 1062,
	"./armenian_big.png": 1063,
	"./azerbaijani.png": 1064,
	"./basque.png": 1065,
	"./belarusian.png": 1066,
	"./bengali.png": 1067,
	"./bosnian.png": 1068,
	"./brazilian portugese.png": 1069,
	"./bulgarian.png": 1070,
	"./canadian french.png": 1071,
	"./catalan.png": 1072,
	"./chinese simplified.png": 1073,
	"./chinese traditional.png": 1074,
	"./chinese.png": 1075,
	"./croatian.png": 1076,
	"./czech.png": 1077,
	"./danish.png": 1078,
	"./dari.png": 1079,
	"./dutch.png": 1080,
	"./english.png": 1081,
	"./english_.png": 1082,
	"./english_backup.png": 1083,
	"./english_old.png": 1084,
	"./english_without_usa.png": 1085,
	"./estonian.png": 1086,
	"./finnish.png": 1087,
	"./flemish.png": 1088,
	"./french.png": 1089,
	"./galician.png": 1090,
	"./german.png": 1091,
	"./greek.png": 1092,
	"./greenlandic.png": 1093,
	"./hebrew.png": 1094,
	"./hindi.png": 1095,
	"./hungarian.png": 1096,
	"./icelandic.png": 1097,
	"./indonesian.png": 1098,
	"./irish.png": 1099,
	"./italian.png": 1100,
	"./japanese.png": 1101,
	"./kazakh.png": 1102,
	"./khmer.png": 1103,
	"./komplet.png": 1104,
	"./korean.png": 1105,
	"./latin.png": 1106,
	"./latvian.png": 1107,
	"./lithuanian.png": 1108,
	"./luxembourgian.png": 1109,
	"./macedonian.png": 1110,
	"./malay.png": 1111,
	"./maltese.png": 1112,
	"./mexican spanish.png": 1113,
	"./moldavian.png": 1114,
	"./montenegrin.png": 1115,
	"./norwegian.png": 1116,
	"./persian.png": 1117,
	"./polish.png": 1118,
	"./portugese.png": 1119,
	"./portuguese-brazilian.png": 1120,
	"./romanian.png": 1121,
	"./russian.png": 1122,
	"./serbian.png": 1123,
	"./slovak.png": 1124,
	"./slovenian.png": 1125,
	"./south-america spanish.png": 1126,
	"./spanish.png": 1127,
	"./swahili.png": 1128,
	"./swedish.png": 1129,
	"./tagalog.png": 1130,
	"./tamil.png": 1131,
	"./thai.png": 1132,
	"./turkish.png": 1133,
	"./turkmen.png": 1134,
	"./ukrainian.png": 1135,
	"./urdu.png": 1136,
	"./usa.png": 1137,
	"./usa_old.png": 1138,
	"./uyghur.png": 1139,
	"./uzbek.png": 1140,
	"./vietnamese.png": 1141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1058;